module.exports = __webpack_public_path__ + "files/bde56fb1fc9a59014294ff8501c47a22.png";